import { createStore } from 'jotai';

// 単一の jotai store を生成し、UI層と API 層で共有する。
// getDefaultStore を避け、テスト時に差し替えやすくするため明示的に export。
export const store = createStore();
